// defaults — build a Studio-ready RuleSet whose `enabledYaku` map is seeded from the master catalog.
// `defaultRuleSet` (protocol) ships an EMPTY enabledYaku (P0 only validated the shape); the Studio is
// where the catalog gets enabled, so we seed every catalog id as enabled-by-default here.
import { defaultRuleSet, type RuleSet, type PlayerCount } from '@mj/protocol';
import { YAKU_CATALOG } from '@mj/engine';
import type { YakuDefMeta } from '@mj/protocol';

export function seededEnabledYaku(catalog: YakuDefMeta[] = YAKU_CATALOG): RuleSet['enabledYaku'] {
  const out: RuleSet['enabledYaku'] = {};
  for (const def of catalog) out[def.id] = { enabled: true };
  return out;
}

/** Default 4-player RuleSet with the full catalog enabled — the Studio's starting point. */
export function studioDefaultRuleSet(players: PlayerCount = 4): RuleSet {
  const rs = defaultRuleSet(players);
  return { ...rs, enabledYaku: seededEnabledYaku() };
}
